import { render } from "./OnlineStatus.vue?vue&type=template&id=0154129a&scoped=true"
import script from "./OnlineStatus.vue?vue&type=script&lang=js"
export * from "./OnlineStatus.vue?vue&type=script&lang=js"

import "./OnlineStatus.vue?vue&type=style&index=0&id=0154129a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0154129a"]])

export default __exports__